// eslint-disable-next-line import/prefer-default-export
export const RequestSource = Object.freeze({
    Offerer: 0,
    Requester: 1,
});
